import { motion } from 'framer-motion'
import { useGame } from '../state/store'
import { CHALLENGES } from '../config/challenges'

export function ChallengePanel() {
  const completedChallenges = useGame((s) => s.completedChallenges)
  const challengeState = useGame((s) => s.challengeState)

  const cs = challengeState()
  const completedSet = new Set(completedChallenges)

  // Build visible challenges: those with no revealAfter, or whose prerequisite is complete
  const visible = CHALLENGES.filter((ch) => {
    if (ch.revealAfter == null) return true
    return completedSet.has(ch.revealAfter)
  })

  const completedCount = visible.filter((ch) => completedSet.has(ch.id)).length

  return (
    <div className="rounded-lg border border-ink-border bg-ink-panel p-3">
      <div className="mb-2 flex items-center justify-between text-xs">
        <span className="font-bold uppercase tracking-widest text-ink-teal">
          Challenges
        </span>
        <span className="text-ink-muted">
          {completedCount} / {visible.length}
        </span>
      </div>
      <div className="space-y-1.5">
        {visible.map((ch) => {
          const done = completedSet.has(ch.id)
          const progress = done ? 1 : ch.progress(cs)
          return (
            <motion.div
              key={ch.id}
              initial={false}
              animate={{ opacity: done ? 0.6 : 1 }}
              className="flex items-center gap-2 text-[11px]"
            >
              <span
                className={`inline-block h-3 w-3 shrink-0 rounded-full border ${
                  done
                    ? 'border-ink-teal bg-ink-teal'
                    : 'border-ink-border bg-ink-bg'
                }`}
              />
              <span className={`flex-1 ${done ? 'text-ink-muted line-through' : 'text-ink-text'}`}>
                {ch.name} — {ch.description}
              </span>
              {!done && progress > 0 && (
                <div className="h-1.5 w-12 overflow-hidden rounded-full bg-ink-border">
                  <div
                    className="h-full rounded-full bg-ink-teal transition-all duration-300"
                    style={{ width: `${Math.min(progress * 100, 100)}%` }}
                  />
                </div>
              )}
            </motion.div>
          )
        })}
      </div>
    </div>
  )
}
